import type { PlcMonitorFields } from "../../../contracts/plc-monitor.js";
import "./operator-plc-monitor.css";

import { plcMonitorPresentation } from "./plc-monitor-presentation";

export function OperatorPlcMonitor({ value, connected, now }: { value: PlcMonitorFields | null; connected: boolean; now: number }) {
  const model = plcMonitorPresentation(value, connected, now);
  return <dl className="operator-plc-monitor" aria-label="PLC arıza ve sensör hızı">
    <div><dt>Arıza durumu</dt><dd className={model.faultFresh && model.faultActive ? "is-fault" : undefined}>{model.fault}</dd></div>
    <div><dt>Sensör hızı</dt><dd>{model.speed}</dd></div>
    <div className="operator-plc-monitor-freshness"><dt>Ölçüm durumu</dt><dd>{model.faultFresh && model.speedFresh ? "Güncel" : "Güncel ölçüm doğrulanamadı"}</dd></div>
  </dl>;
}
